<template>
  <v-menu offset-y left max-height="350">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        elevation="0"
        fab
        small
        :color="$vuetify.breakpoint.mobile ? 'white' : 'transparent'"
      >
        <v-icon v-on="on" color="blue-grey darken-3">mdi-translate</v-icon>
      </v-btn>
    </template>

    <v-list nav dense min-width="254">
      <v-subheader class="blue-grey--text text--darken-2 font-bold">{{
        $t('menu.language').toUpperCase()
      }}</v-subheader>

      <v-list-item-group :value="account.language" color="primary">
        <v-list-item
          v-for="language in availableLanguages"
          :key="language.value"
          :value="language.value"
          @click="setLanguage(language.value)"
        >
          <v-list-item-title class="blue-grey--text text--darken-2">{{
            language.name
          }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import mixin from '@/mixins/mixin.vue'

export default {
  name: 'LanguageSelector',

  mixins: [mixin],

  data() {
    return {
      availableLanguages: this.getLanguages(),
    }
  },

  computed: {
    ...mapGetters(['account', 'organizationId', 'accountId']),
  },

  methods: {
    setLanguage(language) {
      this.$i18n.i18next.changeLanguage(language)
      let safeLanguage = language
      // This conditions are needed because moment doesn't support 'zh' without a dialect and doesn't support 'zu' so we added a fallback to english instead.
      if (language.includes('zh')) safeLanguage = 'zh-cn'
      if (language.includes('zu')) safeLanguage = 'en'

      moment.locale(safeLanguage)

      this.$store.dispatch('updateOwnAccount', {
        organizationId: this.organizationId,
        userId: this.accountId,
        data: { language },
      })
    },
  },
}
</script>
